import {
    ADD_SCHOOLSESSION,
    UPDATE_SCHOOLSESSION,
    RESET_SCHOOLSESSIONS,
  } from "../actions/schoolsessionActionTypes";
  
  const initialState = {
    schoolsessions: [], // Now using an array instead of an object
  };
  
  const schoolsessionReducer = (state = initialState, action) => {
    switch (action.type) {
      case ADD_SCHOOLSESSION:
        return {
          ...state,
          schoolsessions: [...state.schoolsessions, action.payload],
        };
  
      case UPDATE_SCHOOLSESSION:
        return {
          ...state,
          schoolsessions: state.schoolsessions.map((session, index) =>
            index === action.payload.index
              ? { ...session, session_data: action.payload.sessionData }
              : session
          ),
        };
  
      case RESET_SCHOOLSESSIONS:
        return {
          ...state,
          schoolsessions: [],
        };
  
      default:
        return state;
    }
  };
  
  export default schoolsessionReducer;
  